var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icon/attach_email"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3633_6765",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "current"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3633_6765)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "attach_email",
    d: "M19.5332 22C18.5443 22 17.7082 21.6472 17.0249 20.9417C16.3416 20.2361 15.9999 19.3889 15.9999 18.4V13.1667C15.9999 12.5667 16.211 12.0555 16.6332 11.6333C17.0555 11.2111 17.5721 11 18.1832 11C18.7832 11 19.2916 11.2111 19.7082 11.6333C20.1249 12.0555 20.3332 12.5667 20.3332 13.1667V18.5H18.6666V13.1167C18.6666 12.95 18.6249 12.8028 18.5416 12.675C18.4582 12.5472 18.3388 12.4833 18.1832 12.4833C18.0277 12.4833 17.9027 12.5472 17.8082 12.675C17.7138 12.8028 17.6666 12.95 17.6666 13.1167V18.4334C17.6666 18.9834 17.8429 19.4625 18.1957 19.8709C18.5485 20.2792 18.9943 20.4834 19.5332 20.4834C20.0499 20.4834 20.4791 20.2875 20.8207 19.8959C21.1624 19.5042 21.3332 19.0389 21.3332 18.5V13.8833H22.9999V18.5C22.9999 19.4667 22.6638 20.2917 21.9916 20.975C21.3193 21.6583 20.4999 22 19.5332 22ZM2.71653 18C2.24431 18 1.84014 17.8403 1.50403 17.5208C1.16793 17.2014 0.999878 16.8056 0.999878 16.3334V3.66665C0.999878 3.20555 1.16238 2.8125 1.48738 2.4875C1.81238 2.1625 2.20543 2 2.66653 2H19.3332C19.7943 2 20.1874 2.1625 20.5124 2.4875C20.8374 2.8125 20.9999 3.20555 20.9999 3.66665V10.1667H18.0166C17.2166 10.1667 16.5416 10.4611 15.9916 11.05C15.4416 11.6389 15.1666 12.3444 15.1666 13.1667V18H2.71653ZM10.9999 10.6167L19.3332 5.33333V3.66665L10.9999 8.88333L2.66653 3.66665V5.33333L10.9999 10.6167Z",
    fill: "current"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachEmail);
export default __webpack_public_path__ + "static/media/attach_email.adee9caa.svg";
export { ForwardRef as ReactComponent };